export interface EtatSautMascotte { total: number; arrivees: number; visible: boolean; animee: boolean; mouvementReduit: boolean }
/** Une vraie arrivee visible : le rendu choisit un saut ou un fondu selon reduced-motion. */
export function doitSignalerMascotte(avant: EtatSautMascotte | null, apres: EtatSautMascotte): boolean {
  return avant !== null && avant.visible && apres.visible && apres.animee
    && apres.total > avant.total && apres.arrivees > avant.arrivees;
}

export function doitSauterMascotte(avant: EtatSautMascotte | null, apres: EtatSautMascotte): boolean {
  return doitSignalerMascotte(avant, apres) && !apres.mouvementReduit;
}
